import { Project } from "./project.model";

export interface ProjectPlanQuestion {
    id: number;
    text: string;
    type: string;
    options?: string[];
    answer?: string | any[] | null ;
}


export class ProjectPlanResponseModel {
    count: number
    next: string
    previous: string
    results: ProjectPlanModel[]
}

export class ProjectPlanModel {
    created_at: string
    created_by: number
    created_by_name: string
    id: number
    modified_at: string
    modified_by: number
    modified_by_name: string
    onboarding_plan: any[] 
    onboarding_plan_details: any[]
    onboarding_q_plan: any[]
    onboarding_q_plan_details: any[]
    source_project: number 
    project_details: Project
}

export class ProjectQuestionResponseModel {
    count: number
    next: string
    previous: string
    results: ProjectQuestionModel[]
}

export class ProjectQuestionModel {
    created_at: string
    created_by: number
    id: number
    modified_at: string
    modified_by: number
    multiple_choice: string
    question: string
    question_type: number
    question_type_details: any
    auto_selected: boolean
}

export class QuestionFormModel {
    id: number | null = null;
    question: string = '';
    type: number | null = null;
    dropdownOptions: string[] = [];
    autoSelect: boolean = false;
  }
  